import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnDestroy, Output } from '@angular/core';
import { NebularModule } from '../../../common/modules/nebular/nebular.module';
import { CheckoutItem } from '../checkout.service';

interface CheckoutListCellValue {
  type: 'requester' | 'status' | 'action';
  name?: string;
  contact?: string;
  label?: string;
  className?: string;
  canAccept?: boolean;
}

@Component({
  selector: 'ngx-checkout-list-cell',
  standalone: true,
  imports: [CommonModule, NebularModule],
  template: `
    <div *ngIf="value?.type === 'requester'" class="requester">
      <strong>{{ value.name }}</strong>
      <small *ngIf="value.contact">{{ value.contact }}</small>
    </div>

    <span *ngIf="value?.type === 'status'" [class]="value.className">
      {{ value.label }}
    </span>

    <ng-container *ngIf="value?.type === 'action'">
      <button *ngIf="value.canAccept" nbButton size="tiny" status="success"
        type="button" (click)="accept.emit(rowData)">
        <nb-icon icon="checkmark-circle-2-outline"></nb-icon>
        ثبت واریز و تأیید
      </button>
      <span *ngIf="!value.canAccept" class="completed-action">
        <nb-icon icon="checkmark-outline"></nb-icon>
        تعیین تکلیف شده
      </span>
    </ng-container>
  `,
  styles: [`
    .requester {
      display: flex;
      flex-direction: column;
      gap: 0.3rem;
    }

    .requester small {
      color: var(--text-hint-color);
      font-size: 0.75rem;
    }

    .status-badge {
      border-radius: 999px;
      display: inline-flex;
      font-size: 0.72rem;
      font-weight: 600;
      padding: 0.4rem 0.65rem;
      white-space: nowrap;
    }

    .status-badge--success {
      background: var(--color-success-transparent-100);
      color: var(--text-success-color);
    }

    .status-badge--warning {
      background: var(--color-warning-transparent-100);
      color: var(--text-warning-color);
    }

    .status-badge--danger {
      background: var(--color-danger-transparent-100);
      color: var(--text-danger-color);
    }

    .completed-action {
      align-items: center;
      color: var(--text-hint-color);
      display: inline-flex;
      font-size: 0.75rem;
      gap: 0.25rem;
      white-space: nowrap;
    }
  `],
})
export class CheckoutListCellComponent implements OnDestroy {
  @Input() value!: CheckoutListCellValue;
  @Input() rowData!: CheckoutItem;
  @Output() accept = new EventEmitter<CheckoutItem>();

  ngOnDestroy(): void {
    this.accept.complete();
  }
}
